<template>
  <div class="fl">
    <div class="fl-grain"></div>

    <div class="fl-shell">
      <!-- ================= NAV ================= -->
      <header class="fl-nav">
        <div class="fl-wrap">
          <div class="fl-nav__inner">
            <router-link to="/" class="fl-nav__brand">
              <img
                src="@/assets/images/fantaslink_logo.png"
                alt="FantasLink"
              />
            </router-link>

            <nav class="fl-nav__links">
              <a
                v-for="item in sectionLinks"
                :key="item.hash"
                class="fl-nav__link"
                href="javascript:void(0)"
                @click="goToSection(item.hash)"
                >{{ item.label }}</a
              >
              <router-link
                to="/blog"
                class="fl-nav__link"
                :class="{ 'is-active': isBlog }"
                >Blog</router-link
              >
            </nav>

            <div class="fl-nav__cta">
              <a
                class="fl-btn fl-btn--ghost fl-btn--sm"
                href="/account/login"
                >Giriş Yap</a
              >
              <a
                class="fl-btn fl-btn--primary fl-btn--sm"
                href="javascript:void(0)"
                @click="goToSection('uygulama')"
              >
                <i class="mdi mdi-tray-arrow-down"></i>
                Uygulamayı İndir
              </a>
            </div>

            <button
              class="fl-nav__burger"
              type="button"
              :aria-expanded="menuOpen ? 'true' : 'false'"
              aria-label="Menüyü aç"
              @click="menuOpen = !menuOpen"
            >
              <i class="mdi" :class="menuOpen ? 'mdi-close' : 'mdi-menu'"></i>
            </button>
          </div>
        </div>

        <div class="fl-nav__drawer" :class="{ 'is-open': menuOpen }">
          <a
            v-for="item in sectionLinks"
            :key="item.hash"
            href="javascript:void(0)"
            @click="goToSection(item.hash)"
            >{{ item.label }}</a
          >
          <router-link to="/blog" @click.native="menuOpen = false"
            >Blog</router-link
          >
          <a href="/account/login">Giriş Yap</a>
          <a
            class="fl-btn fl-btn--primary"
            href="javascript:void(0)"
            @click="goToSection('uygulama')"
            >Uygulamayı İndir</a
          >
        </div>
      </header>

      <!-- ================= İÇERİK ================= -->
      <main class="fl-main">
        <router-view></router-view>
      </main>

      <!-- ================= FOOTER ================= -->
      <footer class="fl-footer">
        <div class="fl-wrap">
          <div class="fl-footer__grid">
            <div class="fl-footer__brand">
              <img
                src="@/assets/images/fantaslink_logo.png"
                alt="FantasLink"
              />
              <p>
                İçerik üreticileri için link, kampanya ve ödeme yönetimini tek
                yerde toplayan affiliate platformu.
              </p>
            </div>

            <div>
              <h4>Platform</h4>
              <ul>
                <li>
                  <a
                    href="javascript:void(0)"
                    @click="goToSection('ozellikler')"
                    >Özellikler</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0)"
                    @click="goToSection('kampanyalar')"
                    >İçerik Kampanyaları</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0)" @click="goToSection('uygulama')"
                    >Mobil Uygulama</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0)" @click="goToSection('sss')"
                    >Sık Sorulan Sorular</a
                  >
                </li>
              </ul>
            </div>

            <div>
              <h4>Kaynaklar</h4>
              <ul>
                <li><router-link to="/blog">Blog</router-link></li>
                <li>
                  <router-link to="/blog/affiliate-marketing-nedir-influencer-rehberi"
                    >Affiliate Rehberi</router-link
                  >
                </li>
                <li>
                  <router-link to="/blog/influencer-gelirleri-vergi-stopaj-kdv"
                    >Vergi Rehberi</router-link
                  >
                </li>
                <li><a href="/account/register">Ücretsiz Kayıt</a></li>
              </ul>
            </div>

            <div>
              <h4>Yasal</h4>
              <ul>
                <li><a href="/contract/member">Üyelik Sözleşmesi</a></li>
                <li><a href="/contract/data">KVKK Aydınlatma Metni</a></li>
                <li><a href="/contract/cookie">Çerez Politikası</a></li>
                <li>
                  <a href="/privacy-policy.html">Gizlilik Politikası</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="fl-footer__bottom">
            <span>© {{ year }} FantasLink — NewTV Generation</span>
            <span>Tüm hakları saklıdır.</span>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Watch } from "vue-property-decorator";
import "./marketing.css";

@Component
export default class MarketingLayout extends Vue {
  public year = new Date().getFullYear();
  public menuOpen = false;

  public sectionLinks = [
    { hash: "ozellikler", label: "Özellikler" },
    { hash: "kampanyalar", label: "İçerik Kampanyaları" },
    { hash: "uygulama", label: "Mobil Uygulama" },
    { hash: "sss", label: "SSS" },
  ];

  get isBlog(): boolean {
    return (this.$route.path || "").startsWith("/blog");
  }

  @Watch("$route")
  public onRouteChange() {
    this.menuOpen = false;
  }

  /**
   * Bölüm bağlantıları yalnızca ana sayfada bulunur. Blog sayfasındayken
   * önce ana sayfaya dönüp ardından hedefe kaydırırız.
   */
  public goToSection(hash: string) {
    this.menuOpen = false;

    const scroll = () => {
      // Sticky nav yüksekliği kadar pay bırak.
      this.$nextTick(() => {
        window.setTimeout(() => {
          const el = document.getElementById(hash);
          if (!el) return;
          const top =
            el.getBoundingClientRect().top + window.pageYOffset - 84;
          window.scrollTo({ top, behavior: "smooth" });
        }, 60);
      });
    };

    if (this.$route.path === "/") {
      scroll();
    } else {
      this.$router.push("/").then(scroll).catch(() => scroll());
    }
  }
}
</script>
